module.exports = __webpack_public_path__ + "static/media/emoticon-emotion-face-shy-smiley-svgrepo-com.c665ff19.svg";